import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
import Validator from '../../validation/Validator';
import { useIncaForm } from '../../hooks/useInca';
import { registerDesignedFormMethods } from '../../validation/methods';
import legacyValidator from '../../validation';
export const ValidatorContext = /*#__PURE__*/ createContext(legacyValidator);
export const createValidator = (patient)=>{
    const val = new Validator();
    // Registrera endast patient-baserade valideringsregler om det är ett kvalitetsregister.
    if (patient) {
        registerDesignedFormMethods(val, patient);
    }
    return val;
};
export const ValidatorContextWrapper = (props)=>{
    const { children } = props;
    const inca = useIncaForm();
    const ctx = useMemo(()=>{
        return createValidator(inca.patient);
    }, [
        inca
    ]);
    return /*#__PURE__*/ _jsx(ValidatorContext.Provider, {
        value: ctx,
        children: children
    });
};
